<template>
  <tabs v-if="laborder" @TabChange="onTabChange" centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-nav-classes="icon-white" tab-content-classes="tab-content-padding tab-no-space " ref="laborderTabs">
    <!-- Order Details -->
    <tab-pane label="lab-order-details">
      <template slot="label">
        <i class="fa fa-microscope" />
      </template>

      <!-- Patient Details -->
      <div class="col-md-12 mt-3">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Patient Details") }}</h6>
        </div>
        <card>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-user"></i>
                </span>
              </div>
              <div class="col-md-8 col-9 pl-0">
                <span>{{ laborder.patient.firstName }}
                  {{ laborder.patient.lastName }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-info-circle"></i>
                </span>
              </div>
              <div class="col-md-10 col-9 pl-0">
                <span>{{laborder.patient.patientId}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-birthday-cake"></i>
                </span>
              </div>
              <div class="col-md-8 col-9 pl-0">
                <span>{{getAge(laborder.patient.dob)}}</span>
              </div>
            </div>
            <div class="row" v-if="['nurse', 'lab-operator','lab-runner'].includes(user.roles[0])">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-mobile"></i>
                </span>
              </div>
              <div class="col-md-8 col-9 pl-0">
                <span>{{laborder.patient.mobileNumber}}</span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-info-circle"></i>
                </span>
              </div>
              <div class="col-md-10 col-9 pl-0">
                <span>{{laborder.patient.gender}}</span>
              </div>
            </div>

          </div>
        </card>
      </div>

      <!-- Doctor Details -->
      <div class="col-md-12 mt-3" v-if="laborder.appointmentId && laborder.appointmentId.provider">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Doctor Details") }}</h6>
        </div>
        <card>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-user-md"></i>
                </span>
              </div>
              <div class="col-md-8 col-9 pl-0">
                <span>
                  {{ $t("message.Dr") + ' . ' + laborder.appointmentId.provider.firstName + ' ' + laborder.appointmentId.provider.lastName}}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-certificate"></i>
                </span>
              </div>
              <div class="col-md-10 col-9 pl-0">
                <span>{{laborder.appointmentId.provider.specialityText}}</span>
              </div>
            </div>
          </div>
        </card>
      </div>

      <!-- Status Timeline-->
      <div class="col-md-12 mt-3">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Order Status") }}</h6>
        </div>
        <div class="col-md-12">
          <el-timeline>
            <el-timeline-item v-for="(status, index) in labOrderStatus" size='large' :key="index" icon="el-icon-check" :timestamp="getSampleCollectionDatetime(status.timestamp)">
              {{getLabOrderStatus(status.status)}}
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

      <!-- Lab Tests -->
      <div v-if="labTests && labTests.length > 0" class="col-md-12 mt-3">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Lab Tests") }}</h6>
        </div>
        <div>
          <div v-for="labtest in labTests" :key="labtest._id" class="labtest-card">
            <card>
              <div class="">
                <p>{{ labtest.name }}</p>
                <p v-if="!IS_LAB_RUNNER">
                  <i :class="getCurrencyClass(laborder.billingDetails.currency)"></i>
                  <span> {{ labtest.billingDetails.amount }}</span>
                </p>
              </div>
            </card>
          </div>
        </div>
      </div>

      <!-- Health Package -->
      <div v-if="laborder && laborder.healthPackage" class="col-md-12 mt-3">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Health Package") }}</h6>
        </div>
        <div>
          <div class="labtest-card">
            <card>
              <div class="">
                <p>{{ laborder.healthPackage.name }}</p>
              </div>
            </card>
          </div>
        </div>
      </div>

      <!--Sample Collection Location and Time-->
      <div v-if="laborder.sampleCollectionLocation" class="col-md-12 mt-3">
        <div class="col-md-12">
          <h6>{{ $t("message.Sample Collection Details") }}</h6>
        </div>
        <card>
          <div class="row">
            <div class="col-md-1 col-3 text-center">
              <span>
                <i class="fa fa-map-marker-alt"></i>
              </span>
            </div>
            <div class="col-md-8 col-9 pl-0">
              <div class="pb-2" v-if="laborder.sampleCollectionLocation.address">
                <label for="address">{{ $t("message.Address") }}</label>
                <div>{{ laborder.sampleCollectionLocation.address }}</div>
              </div>
              <div>
                <label for="landmark">{{ $t("message.Landmark") }}</label>
                <div>{{ laborder.sampleCollectionLocation.geolocation.landmark }}</div>
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="laborder.sampleCollectionTime">
            <div class="col-md-1 col-3 text-center">
              <span>
                <i class="fa fa-clock"></i>
              </span>
            </div>
            <div class="col-md-8 col-9 pl-0">
              <span>{{ getSampleCollectionDatetime(laborder.sampleCollectionTime)}}</span>
            </div>
          </div>

          <div class="col-12 text-center" v-if="IS_LAB_RUNNER && laborder.latestStatus == 'Accepted' && laborder.sampleCollectionLocation && laborder.sampleCollectionLocation.geolocation &&laborder.sampleCollectionLocation.geolocation.coordinates">
            <n-button type="primary" class="btn-padding light mr-2" round @click.native="navigate()" simple>
              <i slot="label" class="fa fa-route pr-2"></i>
              {{  $t("message.Navigate") }}
            </n-button>
          </div>
        </card>
      </div>

      <!-- Sample Collection Passcode -->
      <div v-if="(IS_NURSE || IS_PATIENT) && laborder.otp" class="col-md-12 mt-3 mb-5">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Sample Collection Passcode") }}</h6>
        </div>
        <card>
          <div class="laborder-passcode">
            {{laborder.otp.sampleCollection}}
          </div>
        </card>
      </div>
      <!-- Sample Deposit Passcode -->
      <div v-if="IS_LAB_OPERATOR && laborder.otp && (laborder.createdBy == 'nurse' || laborder.createdBy == 'patient' || (laborder.createdBy == 'careCoordinator' && laborder.sampleCollectionHome))" class="col-md-12 mt-3 mb-5">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Sample Deposit Passcode") }}</h6>
        </div>
        <card>
          <div class="laborder-passcode">
            {{laborder.otp.sampleDeposit}}
          </div>
        </card>
      </div>

      <!-- Billing Details -->
      <div v-if="!IS_LAB_RUNNER && laborder.billingDetails && laborder.billingDetails.amount" class="col-md-12 mt-3 mb-5">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Total Amount") }}</h6>
        </div>
        <div class="col-md-12 text-center">
          <i :class="getCurrencyClass(laborder.billingDetails.currency)"></i>
          <span> {{ laborder.billingDetails.amount }}</span>
        </div>
      </div>
      <!-- Lab Details -->
      <div class="col-md-12 pb-5" v-if="lab">
        <div class="col-md-12">
          <h6>{{ $t("message.Lab Details") }}</h6>
        </div>
        <card>
          <div class="col-md-12 pl-0">
            <div class="row">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-microscope"></i>
                </span>
              </div>
              <div class="col-md-8 col-9 pl-0">
                <span>{{lab.name}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-map-marker-alt"></i>
                </span>
              </div>
              <div class="col-md-8 col-9 pl-0" v-if="lab.location && lab.location.addressDetails">
                <span>{{lab.location.addressDetails.address}}</span>
              </div>
            </div>

            <div class="col-12 text-center" v-if="IS_LAB_RUNNER && laborder.latestStatus == 'Sample Collected'">
              <n-button type="primary" class="btn-padding light mr-2" round @click.native="navigate()" simple>
                <i slot="label" class="fa fa-route pr-2"></i>
                {{  $t("message.Navigate") }}
              </n-button>
            </div>
          </div>

        </card>
      </div>

      <div class="status-update-buttons">
        <!-- Status update buttons for lab runner -->
        <div v-if="IS_LAB_RUNNER" class="stats text-center">
          <n-button v-if="!SAMPLE_COLLECTED" type="primary" class="btn-padding light mr-2" round @click.native="sampleCollected()">
            <i slot="label" class="fa fa-check pr-2"></i>
            {{  $t("message.Collect Sample") }}
          </n-button>
          <n-button v-if="SAMPLE_COLLECTED && !SAMPLE_DEPOSITED" type="primary" class="btn-padding light mr-2" round @click.native="sampleDeposited()">
            <i slot="label" class="fa fa-check pr-2"></i>
            {{  $t("message.Deposit Sample") }}
          </n-button>
        </div>

        <!-- Status update buttons for lab operator -->
        <!-- checking reports length to show the mark as Completed only if there is atleast one buttton -->
        <div v-if="IS_LAB_OPERATOR" class="stats text-center">
          <n-button type="primary" v-if="isSampleDeposited && !isCompleted && reports.length>0" class="btn-padding light mr-2" round @click.native="updateStatus('Report Uploaded')">
            <i slot="label" class="fa fa-check"></i>
            {{  $t("message.Mark as Complete") }}
          </n-button>
          <n-button type="primary" v-if="isSampleDeposited && !(reports && reports.length>0)" class="btn-padding light mr-2" round @click.native="activeTab=activateTab('lab-reports')">
            <i class="fas fa-file-upload pr-1"></i>
            {{ $t("message.Upload Report") }}
          </n-button>

          <n-button v-if="!SAMPLE_DEPOSITED &&  laborder.latestStatus == 'Created' && laborder.createdBy == 'careCoordinator' && !laborder.sampleCollectionHome" type="primary" class="btn-padding light mr-2" round @click.native="sampleDeposited()">
            <i slot="label" class="fa fa-check pr-2"></i>
            {{  $t("message.Sample Recieved") }}
          </n-button>
        </div>
      </div>
    </tab-pane>

    <!-- Reports -->
    <tab-pane label="lab-reports" v-if="['nurse', 'lab-operator', 'patient'].includes(user.roles[0])">
      <template slot="label">
        <badge type="info" v-if="reports && reports.length>0" style=" height: 2.2em; width: 2.2em; border: 2px solid white; position: absolute; padding: 0.3em; margin-top: 0.5em">{{reports.length}}
        </badge>
        <i class="fas fa-file-medical" />
      </template>
      <div style="height:100%;">
        <div class="col-12 list-wrapper" style="height:100%;">
          <file-card :files="reports" :show-add-button="SHOW_FILE_ADD_BUTTON" :laborder="laborder" :patient-id="laborder.patient.patientId" :delete-control="!isCompleted" :upload-control="!isCompleted"></file-card>
        </div>
        <n-pagination v-if="reportsPagination.totalPages > 1" :page-count="reportsPagination.totalPages" v-model="reportsPagination.pageNumber"></n-pagination>
      </div>
    </tab-pane>
  </tabs>
</template>
<script>
import { TabPane, Tabs } from "src/components";
import FileCard from "../components/FileCard.vue";

export default {
  name: "viewlaborderdetails",
  components: {
    TabPane,
    Tabs,
    FileCard,
  },
  data() {
    return {
      laborder: null,
      labTests: [],
      IS_LAB_RUNNER: false,
      IS_LAB_OPERATOR: false,
      SAMPLE_COLLECTED: false,
      SAMPLE_DEPOSITED: false,
      REPORT_UPLOADED: false,
      SHOW_FILE_ADD_BUTTON: false,
      reports: [],
      reportsPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      lab: {},
      fileUploaded: false,
    };
  },
  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    isCompleted() {
      return this.laborder.latestStatus == "Report Uploaded";
    },
    isSampleDeposited() {
      return this.laborder.status.find((stat) => {
        return stat.status == "Sample Deposited";
      });
    },
    labOrderStatus() {
      let arr = this.laborder.status.filter((status) => {
        return status.status != "Blocked";
      });
      return arr;
    },
  },
  async mounted() {
    this.IS_LAB_RUNNER = this.user.roles.includes("lab-runner");
    this.IS_LAB_OPERATOR = this.user.roles.includes("lab-operator");
    this.IS_NURSE = this.user.roles.includes("nurse");
    this.IS_PATIENT = this.user.roles.includes("patient");

    if (this.user.roles.includes("lab-operator")) {
      this.IS_LAB_OPERATOR = true;
      this.SHOW_FILE_ADD_BUTTON = true;
    }
    this.changeAppHeaderText("lab-order-details");
    await this.getLabOrderDetails();
    await this.getReports();
    this.$forceUpdate();
  },
  watch: {
    reports(value) {
      if (value && value.length > 0) {
        this.fileUploaded = true;
      }
    },
  },
  methods: {
    activateTab(tabname) {
      let tabs = this.$refs.laborderTabs.tabs;
      let tab;
      tabs.forEach((element) => {
        if (element.$el.id == tabname) {
          tab = element;
        }
      });
      this.$refs.laborderTabs.activateTab(tab);
    },
    onTabChange(label) {
      this.changeAppHeaderText(label);
    },
    async getLabOrderDetails() {
      try {
        if (this.$route.params.orderId) {
          this.laborder = await this.$store.dispatch("getLabOrderById", {
            id: this.$route.params.orderId,
          });
          this.labTests = this.laborder.labTests;
          if (this.laborder.status) {
            this.laborder.status.forEach((status) => {
              if (status.status == "Sample Collected") {
                this.SAMPLE_COLLECTED = true;
              } else if (status.status == "Sample Deposited") {
                this.SAMPLE_DEPOSITED = true;
              } else if (status.status == "Report Uploaded") {
                this.REPORT_UPLOADED = true;
              }
            });
          }
          if (this.laborder.lab) {
            let response = await this.$store.dispatch(
              "getEndpointDetails",
              this.laborder.lab
            );
            this.lab = response;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    sampleCollected() {
      let that = this;
      swal
        .fire({
          title: that.$t("message.Please enter the sample collection passcode"),
          input: "text",
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return that.$t("message.Passcode is required");
            } else if (value != that.laborder.otp.sampleCollection) {
              return that.$t("message.Please enter valid passcode");
            }
          },
        })
        .then(async (result) => {
          if (result.value) {
            let status = "Sample Collected";
            let response = await that.$store.dispatch("updateLabOrderStatus", {
              laborderId: that.laborder._id,
              status: status,
            });

            if (response) {
              swal.fire({
                type: "success",
                title: that.$t("message.Status updated successfully!"),
                timer: 3000,
              });
              that.getLabOrderDetails();
            } else {
              swal.fire({
                type: "warning",
                title: that.$t("message.Could not update status"),
                timer: 3000,
              });
            }
          }
        });
    },
    sampleDeposited() {
      let that = this;
      swal
        .fire({
          title: that.$t("message.Please enter the sample deposit passcode"),
          input: "text",
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return that.$t("message.Passcode is required");
            } else if (value != that.laborder.otp.sampleDeposit) {
              return that.$t("message.Please enter valid passcode");
            }
          },
        })
        .then(async (result) => {
          if (result.value) {
            let status = "Sample Deposited";
            let response = await that.$store.dispatch("updateLabOrderStatus", {
              laborderId: that.laborder._id,
              status: status,
            });

            if (response) {
              swal.fire({
                type: "success",
                title: that.$t("message.Status updated successfully!"),
                timer: 3000,
              });

              if (that.user.roles.includes("lab-runner")) {
                that.$router.push({ path: "/labrunnerhome" });
              } else if (that.user.roles.includes("lab-operator")) {
                that.$router.push({ path: "/laboperatorhome" });
              }
            } else {
              swal.fire({
                type: "warning",
                title: that.$t("message.Could not update status"),
                timer: 3000,
              });
            }
          }
        });
    },
    updateStatus(status) {
      let that = this;
      let title = status;

      if (status == "Report Uploaded" && !this.fileUploaded) {
        swal.fire({
          type: "info",
          title: that.$t(
            "message.Kindly upload report before marking as complete!"
          ),
          timer: 5000,
        });
        return;
      }

      switch (status) {
        case "Sample Collected":
          title = this.$t("message.Sample Collected ?");
          break;
        case "Sample Deposited":
          title = this.$t("message.Sample Deposited ?");
          break;
        case "Report Uploaded":
          title = this.$t("message.Are you sure?");
          break;
      }

      swal
        .fire({
          title: title,
          showCancelButton: true,
          closeOnConfirm: true,
          confirmButtonText: that.$t("message.Yes"),
          cancelButtonText:
            status == "Report Uploaded"
              ? that.$t("message.No")
              : that.$t("message.Cancel"),
        })
        .then(async (confirm) => {
          if (confirm.value) {
            let response = await that.$store.dispatch("updateLabOrderStatus", {
              laborderId: that.laborder._id,
              status: status,
            });

            if (response) {
              swal.fire({
                type: "success",
                title: that.$t("message.Status updated successfully!"),
                timer: 3000,
              });

              if (status == "Sample Deposited") {
                if (that.user.roles.includes("lab-runner")) {
                  that.$router.push({ path: "/labrunnerhome" });
                }
              } else {
                that.getLabOrderDetails();
              }
            } else {
              swal.fire({
                type: "warning",
                title: that.$t("message.Could not update status"),
                timer: 3000,
              });
            }
          }
        });
    },
    getFormattedDatetime(timestamp) {
      return Number(timestamp);
    },
    getLabOrderStatus(status) {
      let msgVal = status;
      if (status == "Created") {
        msgVal = this.$t("message.Created");
      }
      if (status == "Accepted") {
        msgVal = this.$t("message.Accepted");
      }
      if (status == "Sample Collected") {
        msgVal = this.$t("message.Sample collected");
      }
      if (status == "Sample Deposited") {
        msgVal = this.$t("message.Sample deposited");
      }
      if (status == "Report Uploaded") {
        msgVal = this.$t("message.Report uploaded");
      }
      return msgVal;
    },
    getSampleCollectionDatetime(timestamp) {
      return moment(Number(timestamp)).format("DD-MM-YYYY, h:mm a");
    },
    async getReports() {
      try {
        if (
          this.laborder &&
          this.laborder.patient &&
          this.laborder.patient.patientId
        ) {
          var query = {
            laborderId: this.laborder._id,
            patientId: this.laborder.patient.patientId,
          };

          let response = await this.$store.dispatch("getFiles", {
            query,
            pageNumber: this.reportsPagination.pageNumber,
            pageSize: "5",
          });

          this.reports = response.data;
          this.reportsPagination.totalPages = response.totalPages;
        }
      } catch (err) {
        console.log(err);
      }
    },
    navigate() {
      let geocoords = "";
      if (this.laborder.latestStatus == "Accepted") {
        // geocoords= lat + "," + lng;
        if (
          this.laborder.sampleCollectionLocation &&
          this.laborder.sampleCollectionLocation.geolocation.coordinates
        ) {
          geocoords =
            this.laborder.sampleCollectionLocation.geolocation.coordinates[1] +
            "," +
            this.laborder.sampleCollectionLocation.geolocation.coordinates[0];
        }
      } else {
        if (
          this.lab &&
          this.lab.location &&
          this.lab.location.addressDetails &&
          this.lab.location.addressDetails.geolocation &&
          this.lab.location.addressDetails.geolocation.coordinates
        ) {
          let coordinates =
            this.lab.location.addressDetails.geolocation.coordinates;
          geocoords = coordinates[1] + "," + coordinates[0];
        }
      }
      if (device.platform == "iOS") {
        window.open("maps://?q=" + geocoords, "_system");
      } else {
        window.open("geo:0,0?q=" + geocoords, "_system");
      }
    },
  },
};
</script>
<style scoped>
/deep/.tab-content {
  height: calc(100% - 68px);
  /* for fixed buttons from bottom */
  position: relative;
}
.content > div {
  height: 100%;
}
.tab-pane.active {
  height: 100%;
  overflow: scroll;
  padding-top: 1em;
  padding-bottom: 3em;
}
.status-update-buttons {
  position: fixed;
  bottom: 3em;
  width: 100%;
}
.el-timeline {
  padding-left: 2em;
}

/deep/.el-timeline-item__icon {
  color: #18ce0f;
}

/deep/.el-timeline-item__node {
  background: white;
  border: solid 1px #18ce0f;
  padding: 0.8em;
  left: -7px;
}
/deep/.el-timeline-item {
  padding-bottom: 30px;
}

/deep/.el-timeline-item__timestamp {
  font-size: 11px;
}
.laborder-passcode {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5em;
}
</style>
